import { messages } from '@/texts/messages'

export class AuthenticationError extends Error {
	constructor(...params) {
		super(...params)
		this.message = messages.authentication_error
	}
}
export class InvalidCredentialsError extends Error {
	constructor(...params) {
		super(...params)
		this.message = messages.invalid_login
	}
}

export class ServerSideError extends Error {
	constructor(...params) {
		super(...params)
		this.message = messages.server_error
	}
}